import { useEffect } from 'react'

import { Metadata } from '@/components/Metadata'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { useLayoutContext } from '@/layout.context'

export interface PageProps extends React.PropsWithChildren {
  metadata?: React.ComponentProps<typeof Metadata>
  permissions?: string[]
  layout?: ReturnType<typeof useLayoutContext>['layout']
}

export const Page: React.FC<PageProps> = ({ metadata, permissions, layout, children }) => {
  const layoutContext = useLayoutContext()

  useEffect(() => {
    layoutContext.setLayout(layout ?? 'normal')
    return () => {
      layoutContext.setLayout('normal')
    }
  }, [])

  return (
    <ProtectedRoute permissions={permissions ?? []}>
      {metadata && <Metadata {...metadata} />}
      {children}
    </ProtectedRoute>
  )
}
